import { selectFetchingProfile } from '../../../store/workspace/selectors';
import AccountInformation from './containers/AccountInformation';
import { getProfileDataThunk } from '../../../store/workspace/thunks';
import PlanInformation from './containers/PlanInformation';
import { useDispatch, useSelector } from '../../../store/store';
import AccountSeats from './containers/AccountSeats';
import AccountSkeleton from './components/Skeleton';
import MotionWrapper from '../../../layouts/MotionWrapper';
import styles from './style.module.scss';
import { useEffect } from 'react';

/** Account settings screen: profile, company, member seats and plans. */
export default function Account() {
    const dispatch = useDispatch();
    const fetchingProfile = useSelector(selectFetchingProfile);

    useEffect(() => {
        dispatch(getProfileDataThunk());
    }, [dispatch]);

    return (
        <MotionWrapper className={styles.container}>
            {fetchingProfile ? <AccountSkeleton /> : (
                <>
                    <AccountInformation />
                    <AccountSeats />
                    <PlanInformation />
                </>
            )}
        </MotionWrapper>
    );
};
